// extracted by mini-css-extract-plugin
export default {"empty":"ContentEmpty_empty__W-r+y","emptyWrapper":"ContentEmpty_emptyWrapper__Mup-m"};